import React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LineRightIconSvg, LineRightSvg } from "../../components/Assets";
import TopPageBack from "../../components/TopPageBack";
import { ROUTE_PATHS } from "../../constants/Router";

const TermAndPolicy = () => {
  const navigate = useNavigate();
  const [list, setList] = useState([
    {
      id: 1,
      title: "서비스 이용 약관",
    },
    {
      id: 2,
      title: "개인정보 및 고유식별정보 수집 및 이용 동의",
    },
    {
      id: 3,
      title: "제 3자 개인정보 제공 동의",
    },
  ]);

  const goToDetail = (item) => {
    navigate(
      ROUTE_PATHS.TermAndPolicyDetails
        .replace(":id", item.id)
        .replace(":title", encodeURIComponent(item.title))
    );
  };

  return (
    <div>
      <TopPageBack>
        <b>약관 및 개인정보 처리 동의</b>
      </TopPageBack>
      <div className="mt-4 mx-5">
        <div className="text-base text-darkblue font-bold mb-8">
          필수 동의 약관
        </div>
        {list.map((item, index) => (
          <div
            onClick={() => goToDetail(item)}
            key={index}
            className="flex items-center justify-between mb-8 "
          >
            <div className="text-15 ">{item.title}</div>
            <div>
              <img src={LineRightIconSvg} alt="right icon" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TermAndPolicy;
